module.exports = __webpack_public_path__ + "static/media/YM54_2.d86b6089.jpg";